import { Notification } from '~/components';
import { useFundAllocationsIncludeCashlikeFund } from '~/hooks';
import { CashLikeFundWarningProps } from './types';

export const CashLikeFundWarning = ({ fundAllocations, ...otherProps }: CashLikeFundWarningProps) => {
    const { includesCashLikeFund } = useFundAllocationsIncludeCashlikeFund(fundAllocations);
    return includesCashLikeFund ? (
        <Notification level="warning" heading="You've selected a cash like (money market) fund" {...otherProps}>
            As a result, your money may not grow enough to meet your needs. It's important to consider where you're
            invested, especially if you need your pension pot to last for the longer term. Everyone's personal
            circumstances are different and the choice is yours.
        </Notification>
    ) : null;
};
